import { sanitizeS3BaseName } from '..';

/**
 * Get the parts of a filename, including its base name and extension
 * @param filename string a filename with the extension, such as "foo.mp3"
 * @returns {FilenameParts} an object containing details of the filename
 */
export const getFilenameParts = (
    filename: string,
    sanitizeBaseName = true,
): FilenameParts => {
    const match = filename.match(/^(.+)\.(\w+)$/);

    let fullName = filename;
    let baseName = null;
    let extension = null;

    if (match !== null) {
        [fullName, baseName, extension] = match;
    }

    return {
        fullName,
        baseName:
            sanitizeBaseName && baseName !== null
                ? sanitizeS3BaseName(baseName)
                : baseName,
        extension,
    };
};
